import React from 'react'
import { Calendar as ReactCalendar } from 'react-big-calendar'
import moment from 'moment'

import CalendarTitle from '../../../../components/pages/Register/CreateBanners/components/Step2/CalendarTitle'
import WeekDaysHeader from '../../../../components/pages/Register/CreateBanners/components/Step2/WeekDaysHeader'
import FindTutorCalendarViewTimeSlot from '../../../student/FindTutor/FindTutorCalendarViewTimeSlot'

import { localizer } from '../../../../constants'

import '../../../student/FindTutor/findTutorCalendarView.css'

const ChangeTimeCalendarView = ({ data, selectedSlot, setSelectedSlot }) => {
  const handleRenderToolbarAfter = () => {
    const hour = parseFloat(data.availability_calendar_detail.slot)
    const selectedHour = parseFloat(selectedSlot?.slot)

    return (
      <div className="w-full mt-[8px] flex items-center gap-x-[32px]">
        <div className="flex items-center gap-x-[10px]">
          <span className="text-sm text-primary-button">Previous Time Selected</span>

          <div className="min-w-[256px] rounded-[10px] bg-white border-[#FFC9AB] border-[1px] h-[44px] px-[24px] flex items-center justify-center text-base text-primary-100">
            {moment(
              `${data.availability_calendar_detail.day} ${hour < 10 && hour > -1 ? `0${hour}` : hour}:00`
            ).format('dddd, MMM DD, hh:mm A')}
          </div>
        </div>

        <div className="flex items-center gap-x-[10px]">
          <span className="text-sm text-primary-button">Changed to</span>

          <div className="min-w-[256px] rounded-[10px] bg-white border-[#FFC9AB] border-[1px] h-[44px] px-[24px] flex items-center justify-center text-base text-primary-100">
            {selectedSlot
              ? moment(
                  `${selectedSlot.day} ${selectedHour < 10 && selectedHour > -1 ? `0${selectedHour}` : selectedHour}:00`
                ).format('dddd, MMM DD, hh:mm A')
              : ''}
          </div>
        </div>
      </div>
    )
  }

  return (
    <ReactCalendar
      className="find-tutor-calendar metaverse-calendar w-full h-[65vh] max-h-[546px] rounded-[12px] text-primary-100"
      defaultView="week"
      startAccessor="start"
      endAccessor="end"
      localizer={localizer}
      defaultDate={new Date()}
      components={{
        toolbar: (props) => <CalendarTitle {...props} renderAfter={handleRenderToolbarAfter} />,
        timeSlotWrapper: (props) => (
          <FindTutorCalendarViewTimeSlot
            {...props}
            slots={data.availability_calendar_detail.class_banner.available_slots}
            selectedSlot={selectedSlot}
            setSelectedSlot={setSelectedSlot}
            alreadySelectedData={data.availability_calendar_detail}
          />
        ),
        header: WeekDaysHeader,
      }}
      timeslots={1}
      step={60}
    />
  )
}

export default ChangeTimeCalendarView
